import React, {useCallback, useState, useEffect, useRef, Fragment} from 'react';
import {Card, Page, Layout, FormLayout, Stack, Spinner, Banner, Checkbox, TextField, Form, Frame, Badge, Button, Toast, Link, Collapsible, Select} from '@shopify/polaris';
import createApp from '@shopify/app-bridge';
import {Redirect} from '@shopify/app-bridge/actions';
import {getSessionToken} from "@shopify/app-bridge-utils";
import {Provider, ResourcePicker} from '@shopify/app-bridge-react';
import ReactHtmlParser from 'react-html-parser';
import {SketchPicker} from 'react-color';
var dateFormat = require('dateformat');

function Home() {
    const [showBanner, setShowBanner] = useState(true);
    const [subscription, setSubscription] = useState(null);
    const [subscriptionText, setSubscriptionText] = useState(null);
    const [subscriptionStatus, setSubscriptionStatus] = useState(null);
    const [hidePriceEnabled, setHidePriceEnabled] = useState(false);
    const [message, setMessage] = useState(null);
    const [messageLoggedCustomers, setMessageLoggedCustomers] = useState(null);
    const [labelLogin, setLabelLogin] = useState(null);
    const [labelRegistration, setLabelRegistration] = useState(null);
    const [fontSize, setFontSize] = useState(14);
    const [styleByPage, setStyleByPage] = useState(false);
    const [fontSizeListingPage, setFontSizeListingPage] = useState(14);
    const [fontSizeProductPage, setFontSizeProductPage] = useState(14);
    const [fontSizeSearchPage, setFontSizeSearchPage] = useState(14);
    const [borderRadius, setBorderRadius] = useState(8);
    const [textColor, setTextColor] = useState('');
    const [hasBackgroundColor, setHasBackgroundColor] = useState(true);
    const [hasBorder, setHasBorder] = useState(true);
    const [borderWidth, setBorderWidth] = useState(2);
    const [backgroundColor, setBackgroundColor] = useState('');
    const [borderColor, setBorderColor] = useState('');
    const [displayTextColorPicker, setDisplayTextColorPicker] = useState(false);
    const [displayBackgroundColorPicker, setDisplayBackgroundColorPicker] = useState(false);
    const [displayBorderColorPicker, setDisplayBorderColorPicker] = useState(false);
    const [currencyConfigured, setCurrencyConfigured] = useState(false);
    const [confirmShopSettings, setConfirmShopSettings] = useState(false);
    const [hasCustomLogin, setHasCustomLogin] = useState(false);
    const [loginUrl, setLoginUrl] = useState('');
    const [hasCustomRegistration, setHasCustomRegistration] = useState(false);
    const [registrationUrl, setRegistrationUrl] = useState('');
    const [config, setConfig] = useState(null);
    const [byProductId, setByProductId] = useState(false);
    const [byProductTags, setByProductTags] = useState(false);
    const [byCollection, setByCollection] = useState(false);
    const [productTags, setProductTags] = useState(false);
    const [byCustomerTags, setByCustomerTags] = useState(false);
    const [customerTags, setCustomerTags] = useState(false);

    // product picker code
    const [productPickerOpen, setProductPickerOpen] = useState(false);
    const [collectionPickerOpen, setCollectionPickerOpen] = useState(false);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [selectedCollections, setSelectedCollections] = useState([]);

    const [pageJustLoadedMessage, setPageJustLoadedMessage] = useState(true);
    const [pageJustLoadedMessageLoggedCustomers, setPageJustLoadedMessageLoggedCustomers] = useState(true);
    const [pageJustLoadedLabelLogin, setPageJustLoadedLabelLogin] = useState(true);
    const [pageJustLoadedLabelRegistration, setPageJustLoadedLabelRegistration] = useState(true);
    const [pageJustLoadedShopSettings, setPageJustLoadedShopSettings] = useState(true);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [submitSuccess, setSubmitSuccess] = useState(false);
    const [uninstallSuccess, setUninstallSuccess] = useState(false);
    const [submitError, setSubmitError] = useState(false);
    const [submitErrorMessage, setSubmitErrorMessage] = useState('Error While Saving Settings');
    const [finalString, setFinalString] = useState(null);

    const [demoOpen, setDemoOpen] = useState(false);

    const [languagesOpen, setLanguagesOpen] = useState(false);
    const languageOptions = [
        {label: 'English', value: 'en'},
        {label: 'Dutch', value: 'nl'},
        {label: 'French', value: 'fr'},
        {label: 'German', value: 'de'},
        {label: 'Greek', value: 'el'},
        {label: 'Spanish', value: 'es'},
        {label: 'Italian', value: 'it'}
    ];
    const [languageData, setLanguageData] = useState([
        { language: 'fr', message: '', loginText: '', registerText: '' }
    ]);

    let messageRef = useRef(message);
    let textColorRef = useRef(textColor);
    let labelLoginRef = useRef(labelLogin);
    let labelRegistrationRef = useRef(labelRegistration);

    useEffect(() => {
        fetchSubscription();
    }, []);

    const fetchSubscription = async () => {
        let configApp = {
            apiKey: window['apiKey'],
            host: window['host']
        };

        setConfig(configApp);
        window['bridge-app'] = createApp(configApp);

        const sessionToken = await getSessionToken(window['bridge-app']);
        // console.log(sessionToken, 'sessionToken');
        if (sessionToken) {
            const settings = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionToken
                }
            };
            const response = await fetch('https://hide-price.webpanda-solutions.com/api/subscription/current/' + window.$queryString, settings);
            // if user session expired reload the page
            if (response.status === 403) {
                console.log('33333333');
                window.location.reload();
                return false;
            }

            const responseJson = await response.json();

            if (response.status === 274) {
                window.location.href = 'https://hide-price.webpanda-solutions.com/login/' + window.$queryString;
                return false;
            }
            if (response.status === 275) {
                const redirect = Redirect.create(window['bridge-app']);
                redirect.dispatch(Redirect.Action.REMOTE, responseJson.redirect_url);
                return false;
            }

            const subscription = responseJson;
            setSubscription(subscription);
            setShowBanner(!subscription.hide_banner);
            setHidePriceEnabled(subscription.hide_price_enabled);
            setMessage(subscription.message);
            setMessageLoggedCustomers(subscription.message_logged_customers);
            messageRef = subscription.message;
            setLabelLogin(subscription.label_login);
            labelLoginRef = subscription.label_login;
            setLabelRegistration(subscription.label_registration);
            labelRegistrationRef = subscription.label_registration;
            setFontSize(subscription.font_size);
            setStyleByPage(subscription.style_by_page);
            setFontSizeListingPage(subscription.font_size_listing_page);
            setFontSizeProductPage(subscription.font_size_product_page);
            setFontSizeSearchPage(subscription.font_size_search_page);
            setBorderRadius(subscription.border_radius);
            setTextColor(subscription.text_color);
            textColorRef = subscription.text_color;
            setHasBackgroundColor(subscription.has_background_color);
            setBackgroundColor(subscription.background_color);
            setHasBorder(subscription.has_border);
            setBorderWidth(subscription.border_width);
            setBorderColor(subscription.border_color);
            setCurrencyConfigured(subscription.currency_configured);
            setHasCustomLogin(subscription.has_custom_login);
            setLoginUrl(subscription.login_url);
            setHasCustomRegistration(subscription.has_custom_registration);
            setRegistrationUrl(subscription.registration_url);
            setByProductId(subscription.by_product_id);
            setByProductTags(subscription.by_product_tags);
            setByCollection(subscription.by_collection);
            setProductTags(subscription.product_tags);
            setByCustomerTags(subscription.by_customer_tags);
            setCustomerTags(subscription.customer_tags);
            if (subscription.language_config && subscription.language_config.length > 0) {
                setLanguageData(JSON.parse(subscription.language_config));
            }

            let now = new Date();
            let trialEnd = new Date(subscription.trial_start);
            if (subscription.id > 95) {
                trialEnd.setDate(trialEnd.getDate() + 14);
            } else {
                trialEnd.setDate(trialEnd.getDate() + 7);
            }

            if (trialEnd > now) {
                setSubscriptionText('Free Trial expires on ' + dateFormat(trialEnd, "dd.mm.yyyy"));
                setSubscriptionStatus(1);
            } else {
                if (subscription.is_premium) {
                    setSubscriptionText('Login to See Price Subscription');
                    setSubscriptionStatus(2);
                } else {
                    setSubscriptionText('Your subscription charge is invalid. Please contact support if you have any questions');
                    setSubscriptionStatus(0);
                    setHidePriceEnabled(false);
                }
            }

            labelLoginRef = '<span class="auth-link">' + labelLoginRef + '</span>';
            labelRegistrationRef = '<span class="auth-link">' + labelRegistrationRef + '</span>';
            let string = subscription.message.replace('{{LOGIN}}', labelLoginRef).replace('{{REGISTRATION}}', labelRegistrationRef);
            // let string = subscription.message.replace('{{LOGIN}}', labelLoginRef);
            setFinalString(string);

            // if premium user we need to load products list
            if (subscription.subscription >= 2) {
                getSessionToken(window['bridge-app'])
                    .then((sessionToken) => {
                        fetch(`https://hide-price.webpanda-solutions.com/api/product/id_list/${window.$queryString}`, {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': 'Bearer ' + sessionToken
                            }
                        }).then(response => {
                            return response.json();
                        }).then(response => {
                            const productsSelected = [];
                            for (let i = 0; i < response.length; i++) {
                                productsSelected.push({ id: 'gid://shopify/Product/' + response[i] });
                            }
                            setSelectedProducts(productsSelected);
                        });
                    })
                    .catch((err) => console.log(err));

                getSessionToken(window['bridge-app'])
                    .then((sessionToken) => {
                        fetch(`https://hide-price.webpanda-solutions.com/api/collection/id_list/${window.$queryString}`, {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': 'Bearer ' + sessionToken
                            }
                        }).then(response => {
                            return response.json();
                        }).then(response => {
                            const collectionsSelected = [];
                            for (let i = 0; i < response.length; i++) {
                                collectionsSelected.push({ id: 'gid://shopify/Collection/' + response[i] });
                            }
                            setSelectedCollections(collectionsSelected);
                        });
                    })
                    .catch((err) => console.log(err));
            }
        }
    };

    const setBannerHidden = () => {
        getSessionToken(window['bridge-app'])
            .then((sessionToken) => {
                const settings = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + sessionToken
                    }
                };
                fetch(`https://hide-price.webpanda-solutions.com/api/subscription/hidebanner/${window.$queryString}`, settings)
                    .then(response => {
                        // if user session expired reload the page
                        if (response.status === 403) {
                            window.location.reload();
                            return false;
                        }

                        setShowBanner(false);
                    });
            })
            .catch((err) => console.log(err));
    };

    const handleShopSettingsSubmit = () => {
        setPageJustLoadedShopSettings(false);

        if (
            confirmShopSettings
        ) {
            setSubmitLoading(true);
            getSessionToken(window['bridge-app'])
                .then((sessionToken) => {
                    fetch(`https://hide-price.webpanda-solutions.com/api/subscription/shopsettings/${window.$queryString}`, {
                        method: 'POST',
                        body: JSON.stringify({'shop_settings': 1}),
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + sessionToken
                        }
                    }).then(response => {
                        if (response.status === 200) {
                            /*setSubmitSuccess(true);
                            setCurrencyConfigured(true);
                            window.scrollTo(0, 0);*/
                            window.location.reload();
                            return false;
                        } else if (response.status === 403) {
                            window.location.reload();
                            return false;
                        }  else {
                            setSubmitError(true);
                        }
                        return response.json();
                    }).then(response => {
                        setSubmitLoading(false);
                    }).catch(err => {
                        setSubmitError(true);
                        setSubmitLoading(false);
                    });
                })
                .catch((err) => console.log(err));
        }
    };

    const handleFormSubmit = () => {
        setPageJustLoadedMessage(false);
        setPageJustLoadedLabelLogin(false);
        setPageJustLoadedLabelRegistration(false);

        if (
            message &&
            labelLogin &&
            labelRegistration
        ) {
            setSubmitLoading(true);

            subscription.hide_price_enabled = hidePriceEnabled;
            subscription.message = message;
            subscription.message_logged_customers = messageLoggedCustomers;
            subscription.label_login = labelLogin;
            subscription.label_registration = labelRegistration;
            subscription.font_size = fontSize;
            subscription.style_by_page = styleByPage;
            subscription.font_size_listing_page = fontSizeListingPage;
            subscription.font_size_product_page = fontSizeProductPage;
            subscription.font_size_search_page = fontSizeSearchPage;
            subscription.border_radius = borderRadius;
            subscription.text_color = textColor;
            subscription.has_background_color = hasBackgroundColor;
            subscription.background_color = backgroundColor;
            subscription.has_border = hasBorder;
            subscription.border_width = borderWidth;
            subscription.border_color = borderColor;
            subscription.currency_configured = currencyConfigured;
            subscription.has_custom_login = hasCustomLogin;
            subscription.login_url = loginUrl;
            subscription.has_custom_registration = hasCustomRegistration;
            subscription.registration_url = registrationUrl;
            subscription.by_product_id = byProductId;
            subscription.by_product_tags = byProductTags;
            subscription.by_collection = byCollection;
            subscription.product_tags = productTags;
            subscription.by_customer_tags = byCustomerTags;
            subscription.customer_tags = customerTags;
            if (subscription.subscription >= 2) {
                subscription.language_config = JSON.stringify(languageData);
            } else {
                subscription.language_config = '';
            }

            getSessionToken(window['bridge-app'])
                .then((sessionToken) => {
                    fetch(`https://hide-price.webpanda-solutions.com/api/subscription/save/${window.$queryString}`, {
                        method: 'POST',
                        body: JSON.stringify(subscription),
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + sessionToken
                        }
                    }).then(response => {
                        if (response.status === 200) {
                            setSubmitSuccess(true);
                        } else if (response.status === 403) {
                            window.location.reload();
                            return false;
                        } else if (response.status === 405) {
                            setSubmitErrorMessage('<span>Your current subscription charge is not active so you are not able to activate the app.</span>');
                            setSubmitError(true);
                            setHidePriceEnabled(false);
                        } else {
                            setSubmitError(true);
                        }
                        return response.json();
                    }).then(response => {
                        setSubmitLoading(false);
                    }).catch(err => {
                        setSubmitError(true);
                        setSubmitLoading(false);
                    });
                })
                .catch((err) => console.log(err));
        }
    };

    /*const changeHideType = (type) => {
        getSessionToken(window['bridge-app'])
            .then((sessionToken) => {
                let submitData = {type: type};

                fetch(`https://hide-price.webpanda-solutions.com/api/subscription/changetype/${window.$queryString}`, {
                    method: 'POST',
                    body: JSON.stringify(submitData),
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + sessionToken
                    }
                }).then(response => {
                    window.location.reload();
                }).catch(err => {
                    setSubmitError(true);
                    setSubmitLoading(false);
                });
            })
            .catch((err) => console.log(err));
    };*/

    const removeFromTheme = () => {
        setSubmitLoading(true);
        getSessionToken(window['bridge-app'])
            .then((sessionToken) => {
                fetch(`https://hide-price.webpanda-solutions.com/api/subscription/uninstall/${window.$queryString}`, {
                    method: 'POST',
                    body: JSON.stringify(subscription),
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + sessionToken
                    }
                }).then(response => {
                    setUninstallSuccess(true);
                    return response.json();
                }).then(response => {
                    setSubmitLoading(false);
                    setHidePriceEnabled(false);
                });
            })
            .catch((err) => console.log(err));
    };

    const updateProductsList = (values) => {
        // console.log(values);
        let productsSelected = [];
        let products = [];
        for (let i = 0; i < values.length; i++) {
            productsSelected.push({ 'id': values[i]['id'] });
            products.push({ 'id': values[i]['id'].replace('gid://shopify/Product/', ''), 'sku': values[i]['handle']} );
        }

        getSessionToken(window['bridge-app'])
            .then((sessionToken) => {
                fetch(`https://hide-price.webpanda-solutions.com/api/product/save_list/${window.$queryString}`, {
                    method: 'POST',
                    body: JSON.stringify({'products': products}),
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + sessionToken
                    }
                }).then(response => {
                    if (response.status === 274) {
                        window.location.href = 'https://hide-price.webpanda-solutions.com/login/' + window.$queryString;
                        return false;
                    }
                    if (response.status === 403) {
                        window.location.reload();
                        return false;
                    }
                    setSelectedProducts(productsSelected);
                    return response.json();
                });
            })
            .catch((err) => console.log(err));
    };

    const updateCollectionsList = (values) => {
        let collectionsSelected = [];
        let collections = [];
        for (let i = 0; i < values.length; i++) {
            collectionsSelected.push({ 'id': values[i]['id'] });
            collections.push({ 'id': values[i]['id'].replace('gid://shopify/Collection/', '')});
        }

        getSessionToken(window['bridge-app'])
            .then((sessionToken) => {
                fetch(`https://hide-price.webpanda-solutions.com/api/collection/save_list/${window.$queryString}`, {
                    method: 'POST',
                    body: JSON.stringify({'collections': collections}),
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + sessionToken
                    }
                }).then(response => {
                    if (response.status === 274) {
                        window.location.href = 'https://hide-price.webpanda-solutions.com/login/' + window.$queryString;
                        return false;
                    }
                    if (response.status === 403) {
                        window.location.reload();
                        return false;
                    }
                    setSelectedCollections(collectionsSelected);
                    return response.json();
                });
            })
            .catch((err) => console.log(err));
    };

    const handleHidePriceChange = useCallback((value) => {
        setHidePriceEnabled(value);
    }, []);

    const handleMessageChange = useCallback((value) => {
        setMessage(value);
        messageRef = value;
        labelLoginRef = '<span class="auth-link">' + labelLoginRef + '</span>';
        labelRegistrationRef = '<span class="auth-link">' + labelRegistrationRef + '</span>';
        let string = messageRef.replace('{{LOGIN}}', labelLoginRef).replace('{{REGISTRATION}}', labelRegistrationRef);
        // let string = messageRef.replace('{{LOGIN}}', labelLoginRef);
        setFinalString(string);
    }, []);

    const handleMessageLoggedCustomersChange = useCallback((value) => {
        setMessageLoggedCustomers(value);
    }, []);

    const handleLabelLoginChange = useCallback((value) => {
        setLabelLogin(value);
        labelLoginRef = value;

        labelLoginRef = '<span class="auth-link">' + labelLoginRef + '</span>';
        labelRegistrationRef = '<span class="auth-link">' + labelRegistrationRef + '</span>';
        let string = messageRef.replace('{{LOGIN}}', labelLoginRef).replace('{{REGISTRATION}}', labelRegistrationRef);
        // let string = messageRef.replace('{{LOGIN}}', labelLoginRef);
        setFinalString(string);
    }, []);

    const handleLabelRegistrationChange = useCallback((value) => {
        setLabelRegistration(value);
        labelRegistrationRef = value;

        labelLoginRef = '<span class="auth-link">' + labelLoginRef + '</span>';
        labelRegistrationRef = '<span class="auth-link">' + labelRegistrationRef + '</span>';
        let string = messageRef.replace('{{LOGIN}}', labelLoginRef).replace('{{REGISTRATION}}', labelRegistrationRef);
        // let string = messageRef.replace('{{LOGIN}}', labelLoginRef);
        setFinalString(string);
    }, []);

    const handleFontSizeChange = useCallback((value) => {
        setFontSize(value);
    }, []);

    const handleStyleByPageChange = useCallback((value) => {
        setStyleByPage(value);
    }, []);

    const handleFontSizeListingPageChange = useCallback((value) => {
        setFontSizeListingPage(value);
    }, []);

    const handleFontSizeProductPageChange = useCallback((value) => {
        setFontSizeProductPage(value);
    }, []);

    const handleFontSizeSearchPageChange = useCallback((value) => {
        setFontSizeSearchPage(value);
    }, []);

    const handleBorderRadiusChange = useCallback((value) => {
        setBorderRadius(value);
    }, []);

    const handleHasBackgroundColorChange = useCallback((value) => {
        setHasBackgroundColor(value);
    }, []);

    const handleHasBorderChange = useCallback((value) => {
        setHasBorder(value);
    }, []);

    const handleBorderWidthChange = useCallback((value) => {
        setBorderWidth(value);
    }, []);

    const handleDisplayTextColorPicker = useCallback((value) => {
        setDisplayTextColorPicker(true)
    }, []);

    const handleTextColorClose = useCallback((value) => {
        setDisplayTextColorPicker(false);
    }, []);

    const handleTextColorChange = useCallback((value) => {
        setTextColor(value.hex);
        textColorRef = value.hex;
    }, []);

    const handleDisplayBackgroundColorPicker = useCallback((value) => {
        setDisplayBackgroundColorPicker(true)
    }, []);

    const handleBackgroundColorClose = useCallback((value) => {
        setDisplayBackgroundColorPicker(false);
    }, []);

    const handleBackgroundColorChange = useCallback((value) => {
        setBackgroundColor(value.hex);
    }, []);

    const handleDisplayBorderColorPicker = useCallback((value) => {
        setDisplayBorderColorPicker(true)
    }, []);

    const handleBorderColorClose = useCallback((value) => {
        setDisplayBorderColorPicker(false);
    }, []);

    const handleBorderColorChange = useCallback((value) => {
        setBorderColor(value.hex);
    }, []);

    const handleConfirmShopSettingsChange = useCallback((value) => {
        setConfirmShopSettings(value);
    }, []);

    const handleHasCustomLoginChange = useCallback((value) => {
        setHasCustomLogin(value);
    }, []);

    const handleLoginUrlChange = useCallback((value) => {
        setLoginUrl(value);
    }, []);

    const handleHasCustomRegistrationChange = useCallback((value) => {
        setHasCustomRegistration(value);
    }, []);

    const handleRegistrationUrlChange = useCallback((value) => {
        setRegistrationUrl(value);
    }, []);

    const handleByProductIdChange = useCallback((value) => {
        setByProductId(value);
        if (value) {
            setByProductTags(false);
            setByCollection(false);
        }
        // changeHideType('by_product_id');
    }, []);

    const handleByProductTagsChange = useCallback((value) => {
        setByProductTags(value);
        if (value) {
            setByProductId(false);
            setByCollection(false);
        }
    }, []);

    const handleByCollectionChange = useCallback((value) => {
        setByCollection(value);
        if (value) {
            setByProductId(false);
            setByProductTags(false);
        }
        // changeHideType('by_collection');
    }, []);

    const handleProductTagsChange = useCallback((value) => {
        setProductTags(value);
    }, []);

    const openResourcePicker = useCallback((value) => {
        setProductPickerOpen(true);
    }, []);

    const closeResourcePicker = useCallback((value) => {
        setProductPickerOpen(false);
    }, []);

    const openCollectionResourcePicker = useCallback((value) => {
        setCollectionPickerOpen(true);
    }, []);

    const closeCollectionResourcePicker = useCallback((value) => {
        setCollectionPickerOpen(false);
    }, []);


    const toggleSubmitSuccess = useCallback(() => {
        setSubmitSuccess(false);
    }, []);

    const toggleUninstallSuccess = useCallback(() => {
        setUninstallSuccess(false);
    }, []);

    const toggleSubmitError = useCallback(() => {
        setSubmitError(false);
    }, []);

    const handleByCustomerTagsChange = useCallback((value) => {
        setByCustomerTags(value);
    }, []);

    const handleCustomerTagsChange = useCallback((value) => {
        setCustomerTags(value);
    }, []);

    const handleLanguagesToggle = useCallback(() => {
        setLanguagesOpen((open) => !open)
    }, []);

    const handleToggleDemo = () => {
		setDemoOpen((open) => !open);
    };

    const handleInputChange = (index, value, element) => {
        const values = [...languageData];

        switch(element) {
            case "language":
                values[index].language = value;
                break;
            case "message":
                values[index].message = value;
                break;
            case "loginText":
                values[index].loginText = value;
                break;
            case "registerText":
                values[index].registerText = value;
                break;
            default:
                // nothing
        }

        setLanguageData(values);
    };

    const hideBanner = () => {
        setShowBanner(false);
        setBannerHidden();
    };

    return (
        <Page>
            <Layout>
                {
                    currencyConfigured ?
                        <Layout.Section>
                            {
                                subscription ?
                                    [
                                        showBanner ?
                                            <Banner
                                                title="App Customization"
                                                status="info"
                                                onDismiss={hideBanner}
                                            >If you need help to configure the app for your store contact us using the "Support"
                                                link and we will help you set it up.
                                            </Banner>
                                            :
                                            null,
                                        <br/>,
                                        <Card title="Subscription" sectioned>
                                            {
                                                subscriptionStatus == 2 ?
                                                    <Badge status="success" size="medium"
                                                           progress="complete">{subscriptionText}</Badge>
                                                    :
                                                    subscriptionStatus == 1 ?
                                                        <Badge status="success" size="medium"
                                                               progress="partiallyComplete">{subscriptionText}</Badge>
                                                        :
                                                        <Badge status="critical" size="medium"
                                                               progress="complete">{subscriptionText}</Badge>
                                            }
                                            <br/>
                                            <br/>
                                            {
                                                subscription.subscription < 3 ?
                                                    <div style={{'font-weight': '600', 'font-size': '15px'}}>
                                                        <p style={{'font-weight': '600', 'font-size': '15px', 'margin-bottom': '10px'}}>Switch to an annual subscription and enjoy a discounted rate.</p>
                                                        <Link url={`/subscription${window.$queryString}`}>Update to Yearly Subscription</Link>
                                                    </div>
                                                    :
                                                    <Link url={`/subscription${window.$queryString}`}>Manage Subscription</Link>
                                            }

                                            {/*<div style={{'color': 'orange', 'font-weight': '600', 'margin-top': '15px'}}>
                                                If you want to Uninstall the app you Need to first remove the code the app added
                                                to your theme by clicking this button &nbsp;&nbsp;
                                                {
                                                    submitLoading ?
                                                        <Button loading size="slim">Remove from Theme</Button>
                                                        :
                                                        <Button onClick={removeFromTheme} size="slim">Remove from Theme</Button>
                                                }
                                            </div>*/}
                                        </Card>
                                    ]
                                    :
                                    null
                            }
                        </Layout.Section>
                        :
                        null
                }
                <Layout.Section>
                    {
                        subscription ?
                            currencyConfigured ?
                                <Form autoComplete={false} onSubmit={handleFormSubmit}>
                                    <Frame>
                                        <Card title="Configuration" sectioned>
                                            <FormLayout>
                                                {
                                                    subscription.id < 1022 ?
                                                        <Checkbox
                                                            label="Enable Hide Price - for Not Logged Customers"
                                                            checked={hidePriceEnabled}
                                                            onChange={handleHidePriceChange}
                                                        />
                                                        :
                                                        <div className="app-status-wrapper" style={{fontSize: '1.4rem', fontWeight: '600'}}>
                                                            <span style={{ marginRight: '20px' }}>
                                                            To Enable the app click this button
                                                            </span>
                                                            <a
                                                                className="Polaris-Button Polaris-Button--primary Polaris-Button--sizeSlim"
                                                                onClick={handleFormSubmit}
                                                                href={`https://${subscription.myshopify_domain}/admin/themes/current/editor?context=apps&activateAppId=e096f673-8110-4907-bc30-a026a34a7e70/app-embed`}
                                                                data-polaris-unstyled="true"
                                                                target="_blank"
                                                            >
                                                                <span className="Polaris-Button__Content">
                                                                    <span className="Polaris-Button__Text">Enable App</span>
                                                                </span>
                                                            </a>
                                                            <br/>
                                                            <br/>
                                                            <Button
                                                                onClick={handleToggleDemo}
                                                                ariaControls="basic-collapsible"
                                                            >
                                                                View App Enable Demo
                                                            </Button>
                                                            <Collapsible
                                                                open={demoOpen}
                                                                id="demo-wrapper"
                                                                transition={{duration: '500ms', timingFunction: 'ease-in-out'}}
                                                            >
                                                                <br/>
                                                                <img src="https://hide-price.webpanda-solutions.com/media/activate-app.gif" alt="Activate app tutorial" style={{ maxWidth: '100%' }} />
                                                            </Collapsible>
                                                        </div>
                                                }
                                                <TextField label="Message for Not Logged Customers" value={message}
                                                    onChange={handleMessageChange}
                                                    error={(message || pageJustLoadedMessage) ? null : "Message is required"}
                                                    multiline={2}
                                                    helpText={
                                                        [
                                                            "Set the text message that will be displayed for not logged customers on your store.",
                                                            <br/>,
                                                            "Use any of these 2 variables to add links to the login/registration pages:",
                                                            <br/>,
                                                            "{{LOGIN}} - link to the login page. You can set the text for it in the field below",
                                                            <br/>,
                                                            "{{REGISTRATION}} - link to the registration page. You can set the text for it in the field below",
                                                        ]}
                                                />
                                                <TextField label="Text of the Login Link" value={labelLogin}
                                                    onChange={handleLabelLoginChange}
                                                    error={(labelLogin || pageJustLoadedLabelLogin) ? null : "Login Link Text is required"}
                                                    helpText={
                                                        [
                                                            "Set the text that will be rendered in the message box for the Login Link.",
                                                        ]}
                                                />
                                                <Checkbox
                                                    label="Shop Has Custom Login URL"
                                                    checked={hasCustomLogin}
                                                    onChange={handleHasCustomLoginChange}
                                                />
                                                {
                                                    hasCustomLogin ?
                                                        <TextField label="Login URL" value={loginUrl}
                                                            onChange={handleLoginUrlChange}
                                                        />
                                                        :
                                                        null
                                                }

                                                <TextField label="Text of the Registration Link" value={labelRegistration}
                                                    onChange={handleLabelRegistrationChange}
                                                    error={(labelRegistration || pageJustLoadedLabelRegistration) ? null : "Registration Link Text is required"}
                                                    helpText={
                                                        [
                                                            "Set the text that will be rendered in the message box for the Registration Link.",
                                                        ]}
                                                />
                                                <Checkbox
                                                    label="Shop Has Custom Registration URL"
                                                    checked={hasCustomRegistration}
                                                    onChange={handleHasCustomRegistrationChange}
                                                />
                                                {
                                                    hasCustomRegistration ?
                                                        <TextField label="Registration URL" value={registrationUrl}
                                                            onChange={handleRegistrationUrlChange}
                                                        />
                                                        :
                                                        null
                                                }

                                                {
                                                    subscription.subscription >= 2 ?
                                                        <Stack vertical>
                                                            <Button
                                                                onClick={handleLanguagesToggle}
                                                                ariaExpanded={languagesOpen}
                                                                ariaControls="basic-collapsible"
                                                            >
                                                                Add Translations
                                                            </Button>
                                                            <Collapsible
                                                                open={languagesOpen}
                                                                id="basic-collapsible"
                                                                transition={{duration: '500ms', timingFunction: 'ease-in-out'}}
                                                                expandOnPrint
                                                            >
                                                                {languageData.map((row, index) => (
                                                                    <Fragment key={`${languageData}~${index}`}>
                                                                        <div style={{'padding': '10px', 'border': '1px solid #F6F6F7', 'border-radius': '4px'}}>
                                                                            <Select
                                                                                label="Language"
                                                                                options={languageOptions}
                                                                                name="language"
                                                                                value={row.language}
                                                                                onChange={event => handleInputChange(index, event, 'language')}
                                                                            />
                                                                            <TextField label="Message for Not Logged Customers"
                                                                                value={row.message}
                                                                                name="message"
                                                                                onChange={event => handleInputChange(index, event, 'message')}
                                                                                multiline={2}
                                                                            />
                                                                            <TextField label="Text of the Login Link"
                                                                                name="loginText"
                                                                                value={row.loginText}
                                                                                onChange={event => handleInputChange(index, event, 'loginText')}
                                                                            />
                                                                            <TextField label="Text of the Registration Link"
                                                                                name="registerText"
                                                                                value={row.registerText}
                                                                                onChange={event => handleInputChange(index, event, 'registerText')}
                                                                            />
                                                                        </div>
                                                                    </Fragment>
                                                                ))}
                                                                <div style={{'height': '20px'}}></div>
                                                            </Collapsible>
                                                        </Stack>
                                                        :
                                                        [
                                                            <Button
                                                                ariaControls="basic-collapsible"
                                                                style={{'display': 'inline-block'}}
                                                                disabled
                                                            >
                                                                Add Translations
                                                            </Button>,
                                                            <span>Premium Only <Link url={`/subscription${window.$queryString}`}>Upgrade</Link></span>
                                                        ]
                                                }

                                                <TextField label="Font Size" type="number"
                                                    value={fontSize.toString()}
                                                    onChange={handleFontSizeChange}
                                                    min={0}
                                                    suffix="px"
                                                />
                                                <Checkbox
                                                    label="Set Font Size per Pages"
                                                    checked={styleByPage}
                                                    onChange={handleStyleByPageChange}
                                                    helpText={
                                                        [
                                                            "If you need to set different font sizes for different pages.",
                                                        ]}
                                                />
                                                {
                                                    styleByPage ?
                                                        [
                                                            <TextField label="Font Size for Product Page" type="number"
                                                                value={fontSizeProductPage.toString()}
                                                                onChange={handleFontSizeProductPageChange}
                                                                min={0}
                                                                suffix="px"
                                                            />,
                                                            <TextField label="Font Size for Homepage and Listing Pages" type="number"
                                                                value={fontSizeListingPage.toString()}
                                                                onChange={handleFontSizeListingPageChange}
                                                                min={0}
                                                                suffix="px"
                                                            />,
                                                            <TextField label="Font Size for Search Page" type="number"
                                                                value={fontSizeSearchPage.toString()}
                                                                onChange={handleFontSizeSearchPageChange}
                                                                min={0}
                                                                suffix="px"
                                                            />
                                                        ]
                                                    :
                                                    null
                                                }




                                                <TextField label="Rounded Corners" type="number"
                                                    value={borderRadius.toString()}
                                                    onChange={handleBorderRadiusChange}
                                                    min={0}
                                                    suffix="px"
                                                />
                                                <Checkbox
                                                    label="Add Background Color to Message Box"
                                                    checked={hasBackgroundColor}
                                                    onChange={handleHasBackgroundColorChange}
                                                />
                                                <Checkbox
                                                    label="Add Border to Message Box"
                                                    checked={hasBorder}
                                                    onChange={handleHasBorderChange}
                                                />
                                                {
                                                    hasBorder ?
                                                        <TextField label="Border Thickness" type="number"
                                                                   value={borderWidth.toString()}
                                                                   onChange={handleBorderWidthChange}
                                                                   min={0}
                                                                   suffix="px"
                                                        />
                                                        :
                                                        null
                                                }
                                                <Stack>
                                                    <div className="color-wrapper">
                                                        <label>Text Color</label>
                                                        <div className="swatch" onClick={handleDisplayTextColorPicker}>
                                                            <div className="swatchColor"
                                                                 style={{'background-color': textColor}} />
                                                        </div>
                                                        {
                                                            displayTextColorPicker ?
                                                                <div className="popover">
                                                                    <div className="cover" onClick={handleTextColorClose} />
                                                                    <SketchPicker color={textColor} onChange={handleTextColorChange} />
                                                                </div>
                                                                :
                                                                null
                                                        }
                                                    </div>
                                                    {
                                                        hasBackgroundColor ?
                                                            <div className="color-wrapper">
                                                                <label>Background Color</label>
                                                                <div className="swatch" onClick={handleDisplayBackgroundColorPicker}>
                                                                    <div className="swatchColor"
                                                                         style={{'background-color': backgroundColor}} />
                                                                </div>
                                                                {
                                                                    displayBackgroundColorPicker ?
                                                                        <div className="popover">
                                                                            <div className="cover" onClick={handleBackgroundColorClose} />
                                                                            <SketchPicker color={backgroundColor} onChange={handleBackgroundColorChange} />
                                                                        </div>
                                                                        :
                                                                        null
                                                                }
                                                            </div>
                                                            :
                                                            null
                                                    }
                                                    {
                                                        hasBorder ?
                                                            <div className="color-wrapper">
                                                                <label>Border Color</label>
                                                                <div className="swatch" onClick={handleDisplayBorderColorPicker}>
                                                                    <div className="swatchColor"
                                                                         style={{'background-color': borderColor}} />
                                                                </div>
                                                                {
                                                                    displayBorderColorPicker ?
                                                                        <div className="popover">
                                                                            <div className="cover" onClick={handleBorderColorClose} />
                                                                            <SketchPicker color={borderColor} onChange={handleBorderColorChange} />
                                                                        </div>
                                                                        :
                                                                        null
                                                                }
                                                            </div>
                                                            :
                                                            null
                                                    }
                                                </Stack>
                                            </FormLayout>
                                        </Card>
                                        <Card title='Hide price and "add to cart" buttons Only for Some Products' sectioned>
                                            <FormLayout>
                                                {
                                                    subscription.subscription >= 2 ?
                                                        [
                                                            byProductId ?
                                                                <Provider config={config}>
                                                                    <ResourcePicker
                                                                        resourceType="Product"
                                                                        // actionVerb={ResourcePicker.ActionVerb.Select}
                                                                        showVariants={false}
                                                                        selectMultiple={true}
                                                                        open={productPickerOpen}
                                                                        initialSelectionIds={selectedProducts}
                                                                        onSelection={({selection}) => {
                                                                            updateProductsList(selection);
                                                                            setProductPickerOpen(false);
                                                                        }}
                                                                        onCancel={closeResourcePicker}
                                                                    />
                                                                </Provider>
                                                                :
                                                                null,
                                                            byCollection ?
                                                                <Provider config={config}>
                                                                    <ResourcePicker
                                                                        resourceType="Collection"
                                                                        // actionVerb={ResourcePicker.ActionVerb.Select}
                                                                        showVariants={false}
                                                                        selectMultiple={true}
                                                                        open={collectionPickerOpen}
                                                                        initialSelectionIds={selectedCollections}
                                                                        onSelection={({selection}) => {
                                                                            updateCollectionsList(selection);
                                                                            setCollectionPickerOpen(false);
                                                                        }}
                                                                        onCancel={closeCollectionResourcePicker}
                                                                    />
                                                                </Provider>
                                                                :
                                                                null
                                                            ,
                                                            <Checkbox
                                                                label="Hide Price for Selected Products"
                                                                checked={byProductId}
                                                                onChange={handleByProductIdChange}
                                                            />,
                                                            byProductId ?
                                                                <Button size="slim" onClick={openResourcePicker}>Select Products</Button>
                                                                :
                                                                null,
                                                            <Checkbox
                                                                label="Hide Price for Products based on Product Tags"
                                                                checked={byProductTags}
                                                                onChange={handleByProductTagsChange}
                                                            />,
                                                            byProductTags ?
                                                                <TextField label="Product Tags" value={productTags}
                                                                    onChange={handleProductTagsChange}
                                                                    helpText={
                                                                        [
                                                                            "Provide a list of product tags separated by ','.",
                                                                            <br/>,
                                                                            "Only the products that have these tags will have the prices hidden."
                                                                        ]
                                                                    }
                                                                />
                                                                :
                                                                null,
                                                            subscription.id < 1275 ?
                                                            [
                                                                <Checkbox
                                                                    label="Hide Price for Selected Collections"
                                                                    checked={byCollection}
                                                                    onChange={handleByCollectionChange}
                                                                />,
                                                            byCollection ?
                                                                <Button size="slim"
                                                                        onClick={openCollectionResourcePicker}>Select
                                                                    Collections</Button>
                                                                :
                                                                null
                                                            ]
                                                            :
                                                            null
                                                        ]
                                                        :
                                                        [
                                                            <Checkbox
                                                                label={
                                                                    [
                                                                        <span>Hide Price for Selected Products - Premium Only </span>,
                                                                        <Link url={`/subscription${window.$queryString}`}>Upgrade</Link>
                                                                    ]
                                                                }
                                                                checked={byProductId}
                                                                disabled
                                                            />,
                                                            <Checkbox
                                                                label={
                                                                    [
                                                                        <span>Hide Price for Products based on Product Tags - Premium Only </span>,
                                                                        <Link url={`/subscription${window.$queryString}`}>Upgrade</Link>
                                                                    ]
                                                                }
                                                                checked={byProductTags}
                                                                disabled
                                                            />,
                                                            /*<Checkbox
                                                                label={
                                                                    [
                                                                        <span>Hide Price for Products based on Collections - Premium Only </span>,
                                                                        <Link url={`/subscription${window.$queryString}`}>Upgrade</Link>
                                                                    ]
                                                                }
                                                                checked={byCollection}
                                                                disabled
                                                            />,*/
                                                        ]
                                                }
                                            </FormLayout>
                                        </Card>
                                        <Card title='Show prices based on Customer Tags - After Login' sectioned>
                                            <FormLayout>
                                                {
                                                    subscription.subscription >= 2 ?
                                                        [
                                                            <Checkbox
                                                                label="Show Price Only for Customers that have specific tags"
                                                                checked={byCustomerTags}
                                                                onChange={handleByCustomerTagsChange}
                                                            />,
                                                            byCustomerTags ?
                                                                [
                                                                <TextField label="Customer Tags" value={customerTags}
                                                                    onChange={handleCustomerTagsChange}
                                                                    helpText={
                                                                        [
                                                                            "Provide a list of customer tags separated by ','.",
                                                                            <br/>,
                                                                            "Only the customers that have these tags will be able to see the product prices."
                                                                        ]
                                                                    }
                                                                />,
                                                                <TextField label="Message for Logged In Customers" value={messageLoggedCustomers}
                                                                    onChange={handleMessageLoggedCustomersChange}
                                                                    error={(messageLoggedCustomers || pageJustLoadedMessageLoggedCustomers) ? null : "Message is required"}
                                                                    multiline={2}
                                                                    helpText={
                                                                        [
                                                                            "Set the text message that will be displayed for logged in customers that don't have the required customer tag on your store."
                                                                        ]}
                                                                />
                                                                ]
                                                                :
                                                                null
                                                        ]
                                                        :
                                                        [
                                                            <Checkbox
                                                                label={
                                                                    [
                                                                        <span>Show Price Only for Customers that have specific tags - Premium Only </span>,
                                                                        <Link url={`/subscription${window.$queryString}`}>Upgrade</Link>
                                                                    ]
                                                                }
                                                                checked={byCustomerTags}
                                                                disabled
                                                            />
                                                        ]
                                                }
                                            </FormLayout>
                                        </Card>
                                        <br/>
                                        {
                                            submitLoading ?
                                                <div className="main-button-wrapper">
                                                    <Button submit primary loading>Save</Button>
                                                </div>
                                                :
                                                <div className="main-button-wrapper">
                                                    <Button submit primary>Save</Button>
                                                </div>
                                        }
                                        {
                                            submitSuccess ?
                                                <Toast content="Settings Saved" onDismiss={toggleSubmitSuccess} />
                                                :
                                                null
                                        }
                                        {
                                            uninstallSuccess ?
                                                <Toast content="App Code Removed from Theme" onDismiss={toggleUninstallSuccess} />
                                                :
                                                null
                                        }
                                        {
                                            submitError ?
                                                <Toast content={ReactHtmlParser (submitErrorMessage)} error onDismiss={toggleSubmitError} />
                                                :
                                                null
                                        }
                                    </Frame>
                                </Form>
                                :
                                <Card title="Shop Setup" sectioned>
                                    <div style={{fontSize: '1.1em'}}>
                                        <p>Before using the app, you need to edit your store's currency format to make the app work properly on your store.</p>
                                        <br/>
                                        <p>1. Select <strong>Settings</strong> from the bottom left area of your Shopify Admin:</p>
                                        <br/>
                                        <img className="store-setup-image" src="https://hide-price.webpanda-solutions.com/media/step1.png" alt="Step 1"/>
                                        <br/>
                                        <br/>
                                        <p>2. In <strong>Store currency</strong> section, select <strong>Change formatting</strong>:</p>
                                        <br/>
                                        <img className="store-setup-image" src="https://hide-price.webpanda-solutions.com/media/step3.png" alt="Step 3"/>
                                        <br/>
                                        <br/>
                                        <p>3. Replace the <strong>HTML with currency</strong> input with the code below:</p>
                                        <pre>
                                            <code>{subscription['money_with_currency_format']}</code>
                                        </pre>
                                        <p>4. Replace the <strong>HTML without currency</strong> input with the code below:</p>
                                        <pre>
                                            <code>{subscription['money_format']}</code>
                                        </pre>
                                        <br/>
                                        <img className="store-setup-image" src="https://hide-price.webpanda-solutions.com/media/step4-5.png" alt="Step 4"/>
                                        <br/>
                                        <br/>
                                        <p>5. Click <strong>Save</strong> to apply your settings:</p>
                                        <br/>
                                        <img className="store-setup-image" src="https://hide-price.webpanda-solutions.com/media/step6.png" alt="Step 6"/>
                                        <br/>
                                        <br/>
                                        <p style={{'color': 'orange'}}>If you uninstall the app you should reverse these changes and set the fields to the initial value.</p>
                                        <p style={{'color': 'orange'}}>But even if you don't it won't affect the shop in any way.</p>
                                        <br/>
                                        <Form autoComplete={false} onSubmit={handleShopSettingsSubmit}>
                                            <Frame>
                                                <div className="shop-setup-confirm">
                                                    <Checkbox
                                                        label="Confirm you have updated the Currency Shop Settings"
                                                        checked={confirmShopSettings}
                                                        onChange={handleConfirmShopSettingsChange}
                                                        error={(confirmShopSettings || pageJustLoadedShopSettings) ? null : "You need to confirm the Shop Settings are done to be able to continue"}
                                                    />
                                                    {
                                                        submitLoading ?
                                                            <div className="main-button-wrapper">
                                                                <Button submit primary loading>Continue to App ></Button>
                                                            </div>
                                                            :
                                                            <div className="main-button-wrapper">
                                                                <Button submit primary>Continue to App ></Button>
                                                            </div>
                                                    }
                                                    {
                                                        submitSuccess ?
                                                            <Toast content="Settings Saved" onDismiss={toggleSubmitSuccess} />
                                                            :
                                                            null
                                                    }
                                                </div>
                                            </Frame>
                                        </Form>
                                    </div>
                                </Card>
                            :
                            <Card sectioned>
                                <Spinner accessibilityLabel="Spinner example" size="large" color="teal" />
                            </Card>

                    }
                </Layout.Section>
                {
                    currencyConfigured && subscription ?
                        <Layout.Section secondary>
                            <Card title="Live Preview" sectioned>
                                <div className="preview-wrapper">
                                    <img src="https://hide-price.webpanda-solutions.com/media/product-image.jpg" alt="Product Image"/>
                                    <div className="product-name">Some Nice Shoes</div>
                                    {
                                        hasBackgroundColor ?
                                            <span className="panda-hide-price"
                                                  style={{
                                                      fontSize: fontSize + 'px',
                                                      color: textColor,
                                                      backgroundColor: backgroundColor,
                                                      border: hasBorder ? borderWidth + 'px solid ' + borderColor : 'none',
                                                      padding: '8px',
                                                      borderRadius: borderRadius + 'px'
                                                  }}
                                            >
                                                {/*{finalString}*/}
                                                {ReactHtmlParser(finalString)}
                                            </span>
                                            :
                                            <span className="panda-hide-price"
                                                  style={{
                                                      fontSize: fontSize + 'px',
                                                      color: textColor,
                                                      border: hasBorder ? borderWidth + 'px solid ' + borderColor : 'none',
                                                      padding: '8px',
                                                      borderRadius: borderRadius + 'px'
                                                  }}
                                            >
                                                {/*{finalString}*/}
                                                {ReactHtmlParser(finalString)}
                                            </span>
                                    }

                                </div>
                            </Card>
                        </Layout.Section>
                        :
                        null
                }
            </Layout>
        </Page>
    );
}

export default Home;
